"use client";

import { useState } from "react";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { Toaster } from "sonner";

export default function Providers({ children }) {
    const [queryClient] = useState(
        () =>
            new QueryClient({
                defaultOptions: {
                    queries: {
                        staleTime: 60 * 1000,
                    },
                },
            }),
    );

    return (
        <QueryClientProvider client={queryClient}>
            {children}
            <Toaster
                closeButton
                position="top-center"
                expand
                toastOptions={{
                    unstyled: true,
                    duration: 7500,
                    classNames: {
                        toast: "bg-white rounded border-l-4 shadow items-center gap-x-2 w-max max-w-md",
                        title: "font-lato text-neutral-100",
                        description: "font-lato text-neutral-100",
                        success: "border-l-green-140",
                        error: "border-l-red-100",
                        info: "border-l-primary-100",
                    },
                }}
            />
        </QueryClientProvider>
    );
}
